import { render, staticRenderFns } from "./_bulk_tag_records_modal.vue?vue&type=template&id=e24fdc82&scoped=true&"
import script from "./_bulk_tag_records_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_tag_records_modal.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_tag_records_modal.vue?vue&type=style&index=0&id=e24fdc82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24fdc82",
  null
  
)

export default component.exports